module.exports = __webpack_public_path__ + "img/TSGModulLadestation.caad197b.png";